import { axiosMock } from 'utils/axios';

axiosMock.onGet('/api/users').reply(200, {
  users: [],
});
